import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import {
    MessageBanner,
} from '@ratehub/base-ui';

import classNames from 'classnames';
import isProviderRate from '../functions/isProviderRate';
import MortgageRateSelector from './MortgageRateSelector';


function MortgageRateSelectorGroup({ providerRates, initialCustomRate, onSelectRate }) {
    return (
        <section>
            <Choose>
                <When condition={providerRates?.length}>
                    <For
                        each="rate"
                        // custom rate must always be the 5th item even if they expand the list
                        of={[ ...providerRates.slice(0, 4), { value: initialCustomRate }, ...providerRates.slice(4) ]}
                        index="index"
                    >
                        <MortgageRateSelector
                            key={isProviderRate(rate) ? rate.id : 'customRate'}
                            className={classNames({
                                'rh-bt-1px-solid-stone': index !== 0, // top border conflicts with FilteredAsyncContainer
                            })}
                            rate={rate}
                            onSelectRate={onSelectRate}
                        />
                    </For>
                </When>
                <Otherwise>
                    <MessageBanner
                        className="rh-m-0_5"
                        variant="error"
                        iconKey="exclamation-mark"
                        message={(
                            <FormattedMessage
                                id="mtg-common.MortgageRateSelectorGroup.errorBannerMessage"
                                defaultMessage="No rate results. Please adjust your filter and search again."
                            />
                        )}
                    />
                </Otherwise>
            </Choose>
        </section>
    );
}


MortgageRateSelectorGroup.propTypes = {
    providerRates: PropTypes.array, // rates API response object
    onSelectRate: PropTypes.func.isRequired,
    initialCustomRate: PropTypes.number,
};

MortgageRateSelectorGroup.defaultProps = {
    providerRates: undefined,
    initialCustomRate: undefined,
};

export default observer(MortgageRateSelectorGroup);
